import { createReducerContext } from '../../../../utils/create-reducer-context';
import { MenuState, MenuReducer, ACTION_TYPES } from './menu-reducer';

const initialState: MenuState = {
    menus: [],
    loadingMenus: false,
    items: [],
    loadingItems: false,
    menuDrawer: { open: false },
    itemDrawer: { open: false },
};

const { Provider: MenuProvider, useStateContext: useMenuState, useDispatchContext: useMenuDispatch } = createReducerContext('Menu', MenuReducer, initialState);

export { MenuProvider, useMenuState, useMenuDispatch, ACTION_TYPES };
